import React from "react";
import { useMediaQuery } from "react-responsive";
import { Slide, ToastContainer } from "react-toastify";

export default function ToastProvider({ children }) {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return (
    <>
      {children}
      <ToastContainer
        className="bcp-toastify"
        position={isMobile ? "top-center" : "bottom-right"}
        autoClose={5000}
        transition={Slide}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        toastClassName="bcp-toast"
        bodyClassName="bcp-toast-body"
      />
    </>
  );
}
